module.exports = __webpack_public_path__ + "static/media/qixingshan_mobile.7c4cd4d8.webp";